export default __webpack_public_path__ + "static/chris-b1a6c4bc198ea602ad054e057cfd6acd.png";